import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../containers/dockPadStyle'
import classNames from 'classnames'
import { compose } from 'redux'
import { isObject } from 'util';
import AsyncCreatableSelect from 'react-select/async-creatable';


const MySelect = props => {

  let SelectComponent
  if (!!props.onCreateOption || props.createOption === true) {
    SelectComponent = CreatableSelect
  } else {
    SelectComponent = Select
  }

  let placeholder = props.placeholder

  if(!placeholder) {
    if (!!props.onCreateOption || props.createOption === true) {
      placeholder = "Select or Type something and press enter..."
    } else {
      placeholder = "Select..."
    }
  }
  

  if (props.allowSelectAll && props.isMulti) {
    return (
      <SelectComponent
        isMulti={true}
        value={props.value}
        placeholder={placeholder}
        onCreateOption={props.onCreateOption}
        options={[props.allOption, ...props.options]}
        onChange={(selected, event) => {
          console.log('SelectComponent', selected, event)
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === props.allOption.value) {
              return props.onChange([...props.options]);
            }
            let result = [];
            if (selected.length === props.options.length) {
              if (selected.includes(props.allOption)) {
                result = selected.filter(
                  option => option.value !== props.allOption.value
                );
              } else if (event.action === "select-option") {
                result = [props.allOption, ...props.options];
              }
              return props.onChange(result);
            }
          }



          return props.onChange(selected);
        }}
      />
    );
  }

  return <SelectComponent                 value={props.value}

  onChange={(selected, event) => {
    if (selected !== null && selected.length > 0) {
      if (selected[selected.length - 1].value === props.allOption.value) {
        return props.onChange([...props.options]);
      }
      let result = [];
      if (selected.length === props.options.length) {
        if (selected.includes(props.allOption)) {
          result = selected.filter(
            option => option.value !== props.allOption.value
          );
        } else if (event.action === "select-option") {
          result = [props.allOption, ...props.options];
        }
        return props.onChange(result);
      }
    }

    return props.onChange(selected);
  }} options={[ ...props.options]} placeholder={placeholder}  onCreateOption={props.onCreateOption} />;
};

MySelect.propTypes = {
  placeholder: PropTypes.string,
  onCreateOption: PropTypes.func,
  createOption:  PropTypes.bool,
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MySelect.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*"
  },
  createOption: false
};

class SelectList extends React.Component {
  render() {
    const { classes, disabled, isMulti, allowSelectAll, onCreateOption, createOption, placeholder } = this.props
    const options = this.props.optionList.map(item => {
      return {
        value: item.uid,
        label: !!item.email ? item.email : item.name
      }
    })


    const value = options.filter(
      item => {
        return ((Array.isArray(this.props.value) || isObject(this.props.value)) && item.value in this.props.value)  || item.value === this.props.value
      }
    )

    return (
      <div style={{width: '100%'}}>
        <Typography>{this.props.title}</Typography>
        <MySelect

          placeholder={placeholder}
          createOption={createOption}
          onCreateOption={onCreateOption}
          isMulti={isMulti}
          isDisabled={disabled}
          value={value}
          onChange={this.props.onChange}
          options={options}
          allowSelectAll={allowSelectAll}
        />
      </div>
    )
  }
}

SelectList.propTypes = {
  allowSelectAll: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  optionList: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]),
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool.isRequired,
  onCreateOption: PropTypes.func,
}

SelectList.defaultProps = {
  onChange: () => {},
  optionList: [],
  value: [],
  title: 'Assignees',
  disabled: false,
  isMulti: true,
  allowSelectAll: true
}

export default compose(withStyles(styles, { withTheme: true }))(SelectList)



// WEBPACK FOOTER //
// ./src/components/SelectList.tsx